import merge from 'deepmerge'

const salesOrderPrintHTML = {
  data() {
    return {
      templateColumns: [{title:'Item',name:'sku',width:15},{title:'Description',name:'description',width:35},
                        {title:'Tax',name:'tax',width:10},{title:'Qty',name:'quantity',width:15,right:true},
                        {title:'Rate',name:'unitPrice',width:15,right:true},{title:'Amount',name:'amount',width:15,right:true}
                       ],
      templateFields: [{title:'Order #',name:'number'},{title:'Date',name:'date',date:true},
                       {title:'Expected',name:'due', date:true},{title:'Customer PO',name:'po'},
                       {title:'Terms',name:'terms'},
                       {title:'Sales rep',name:'salesRepName'},
                       {title:'Ship via',name:'shipVia'},{title:'Licensee #',name:'customerLicense'}
                      ],
      templateForm: {
        margins: {
          top: .5,
          left: .25,
          bottom: .5,
          right: .25
        },
        top: {
          style: 0,
          company: {
            logo: true,
            logoHeight: 72,
            name: {
              show: true,
              bold: true,
              size: 120
            },
            address: true,
            phone: true,
            email: true
          },
          title: {
            size: 300,
            bold: true,
            shaded: true
          }
        },
        info: {
          position: 1,    // 0 = top, 1 = bill to, 2 = below
          true: false,
          lines: true,
          fields: [],
          shipTo: true
        },
        title: {
          bold: true,
          shaded: true,
          lines: true,
          upperCase: true
        },
        valueLines: true,
        columnDividers: false,
        totalLines: false,
        columns: [],
      },
      fields: [],
      columns: [],
      form: null,
    }
  },
  computed: {
    infoColumns() {
      return this.info.box ? Math.ceil(this.form.info.fields.length / 2) : 2;
    },
    margins() {
      return this.form?.margins ?? {};
    },
    info() {
      return this.form?.info ?? {};
    },
    top() {
      return this.form?.top ?? {};
    },
    title() {
      return this.form?.title ?? {};
    },
    totalWidth() {
      return this.form.columns.reduce((total, columnName) => total + this.columns.find(column => column.name === columnName).width, 0);
    }
  },
  async created() {
    const results = await this.$apiCall(`query salesOrderPrintHTML {
                                            printForm(name:"salesorder")
                                          }`);
    if (!results.error)
      this.form = merge(this.templateForm, JSON.parse(results.data.printForm));
/*
                       {arrayMerge: (destinationArray, sourceArray) => {
                                      sourceArray.forEach(item => {
                                        if (!destinationArray.includes(item))
                                          destinationArray.push(item)
                                      });
                                      return destinationArray;
                                    }
                       });
                       */
    if (!this.form.info.fields.length)  // Set up default fields
      this.form.info.fields = ['number','date','due','po','shipVia','terms'];

    // Arrange fields list to prioritize used fields, in order
    for (const fieldName of this.form.info.fields)   // Put used fields in order into list
      this.fields.push(this.templateFields.find(field => field.name === fieldName));
    for (const field of this.templateFields) {          // Put remaining unused fields into list
      if (!this.fields.some(f => f.name === field.name))
        this.fields.push(field);
    }

    if (!this.form.columns.length)  // Set up default columns
      this.form.columns = ['sku','description','tax','quantity','unitPrice','amount'];

    // Arrange columns list to prioritize used columns, in order
    for (const columnName of this.form.columns)   // Put used columns in order into list
      this.columns.push(this.templateColumns.find(column => column.name === columnName));
    for (const column of this.templateColumns) {          // Put remaining unused columns into list
      if (!this.columns.some(f => f.name === column.name))
        this.columns.push(column);
    }
  },
  methods: {
    printTop(company, salesOrder) {
      const top = this.form.top;
      return `
        <tr>
        ${top.style === 0 ? this.printTopCompany(top, company, salesOrder) : this.printTopTitle(top, salesOrder)}
        ${top.style === 0 ? this.printTopTitle(top, salesOrder) : this.printTopCompany(top, company, salesOrder)}
        </tr>
      `;
    },
    printTopCompany(top, company, salesOrder) {
      const formCompany = top.company;
      return `
        <th colspan="8">
          ${formCompany.logo ? `<img id="${salesOrder.id}" style="height:${formCompany.logoHeight}px;vertical-align:top" src="${company.logoURL}"/>` : ``}
          <div style="display:inline-block;margin-left:10px;line-height:18px">
            ${formCompany.name.show ? `<span style="${formCompany.name.bold ? 'font-weight:bold;':''}font-size:${formCompany.name.size}%">${company.name}</span><br/>` : ``}
            ${formCompany.address ? `${company.address || ''}<br/>${company.city || ''} ${company.province || ''}  ${company.postalCode || ''}<br/>` : ``}
            ${formCompany.phone ? `${company.phone || ''}</br>` : ``}
            ${formCompany.email ? `${company.email || ''}` : ``}
          </div>
        </th>
      `;
    },
    printTopTitle(top, salesOrder) {
      const formTitle = top.title;
      return `
        <th style="${formTitle.shaded?'color:#aaa':''};font-size:${formTitle.size}%;${formTitle.bold?`font-weight:700`:``};text-align:${top.style === 0 ? 'right' : 'left'}" colspan="12">SALES ORDER</th>
      `;
    },
    printInfoBox(salesOrder, columns, maxRows) {
      const info = this.form.info;
      const lines = [`<table width="100%" style="border-collapse:collapse">
                        <tbody>`];

      const numberOfFields = info.fields.length;
      const columnWidth = `${100/columns}%`;
      let titleField = 0;
      let valueField = 0;
      let rows = 0;
      while (titleField < numberOfFields /*&& rows < maxRows*/) {
        lines.push(`<tr>`)
        for (let column = 0; column < columns && titleField < numberOfFields; column++) {
          const field = this.fields.find(field => field.name === info.fields[titleField]);
          lines.push(`<th width="${columnWidth}" class="title-style text-center">${field.title}</th>`);
          titleField++;
        }
        lines.push(`</tr><tr>`);
        for (let column = 0; column < columns && valueField < numberOfFields; column++) {
          const field = this.fields.find(field => field.name === info.fields[valueField]);
          let value = salesOrder[field.name];
          if (field.date)
            value = this.$formatDate(value);
          lines.push(`<th width="${columnWidth}" class="title-value-style">${value ?? ''}&nbsp;</th>`);
          valueField++;
        }
        lines.push(`</tr>`);
        rows++;
      }
      lines.push(`</tbody></table>`);
      return lines.join('');
    },
    printInfoPlain(salesOrder) {
      const info = this.form.info;
      const lines = [`
        <table width="100%" style="border-collapse:collapse">
          <tbody>`];
      let titleField = 0;
//      const numberOfFields = Math.min(info.fields.length, 4);
      const numberOfFields = info.fields.length;
      while (titleField < numberOfFields) {
        lines.push(`<tr>`)
        const field = this.fields.find(field => field.name === info.fields[titleField]);
        lines.push(`<th width="50%" class="title-plain-style">${field.title}:</th>`);
        let value = salesOrder[field.name];
        if (field.date)
          value = this.$formatDate(value);
        lines.push(`<th width="50%" style="text-indent:5px">${value ?? ''}&nbsp;</th>`);
        lines.push(`</tr>`);
        titleField++;
      }
      lines.push(`</tbody></table>`);
      return lines.join('');
    },
    displayAddress(address) {
      let count = (address.match(/\n/g) || []).length
      let display = address.replace(/\n/gi,'<br/>');
      while (count++ < 2)   // Make sure we have at least 3 lines
        display += '<br/>';
      return display;
    },
    print(company, salesOrder) {
      if (!this.form)   // In case it's not ready yet
        return;
      const info = this.form.info;
      const cols = `<col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
                    <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
                    <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
                    <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
                    <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>`;
      const lines = [`
        <style>
          @page {size:portrait}
          .sales-order-print {font-family: Roboto, sans-serif;
                          width:calc(100% - ${this.form.margins.left+this.form.margins.left}in);
                          border-spacing:0;font-size:12px;text-align:left;bokrder-collapse:collapse;table-layout:fixed;
                          margin-top:${this.form.margins.top}in; margin-left:${this.form.margins.left}in; margin-right:${this.form.margins.right}; margin-bottom:${this.form.margins.bottom}}
          .sales-order-print th {font-weight:normal;vertical-align:top;font-size:11px;text-align:left}

          .sales-order-print .title-style {padding:4px 8px;text-align:center;font-size:12px;${this.title.bold?`font-weight:bold`:''};${this.title.shaded?`background-color:#b4b4b4`:``};${this.title.lines?`border:1px solid #888`:``};${this.title.upperCase?`text-transform:uppercase`:``}}
          .sales-order-print .title-value-style {padding:4px 8px;text-align:center;font-size:11px;${this.form.valueLines?`border:1px solid #888`:``}}
          .sales-order-print .title-plain-style {text-align:right;font-size:12px;${this.title.bold?`font-weight:bold`:''};${this.title.upperCase?`text-transform:uppercase`:``}}

          .sales-order-print .separator {border-top:thin solid #888}
          .sales-order-print .total-line {text-align:right${this.form.valueLines && this.form.totalLines ? ';border-right:thin solid #888' : ''}}
          .sales-order-print td {padding:4px 8px; font-size:11px}
          .sales-order-print .right {text-align:right}
          .page-break {page-break-before: always}
          .sales-order-print .draft {font-size:50px;opacity:0.2;text-align:center}
        </style>
        <table class="sales-order-print">
          ${cols}
          <thead>
            ${this.printTop(company, salesOrder)}
            <tr><th colspan="20">&nbsp;</th></tr>
            ${info.position === 0 ? `<tr>
                                   <th colspan="${20 - this.infoColumns * 4}"/>
                                   <th colspan="${this.infoColumns * 4}">
                                    ${info.box ? this.printInfoBox(salesOrder, Math.min(5, this.infoColumns), 2) : this.printInfoPlain(salesOrder)}
                                   </th>
                                 </tr><tr><th colspan="20">&nbsp;</th></tr>` : ''}


            <!-- Bill to, (Ship to), (Info) -->
            <tr>
              <th colspan="5" class="title-style" style="text-align:left">Bill to</th>
              <th rowspan="4"/>
              ${info.shipTo ? `<th colspan="5" class="title-style" style="text-align:left">Ship to</th>`
                                 : `<th colspan="${this.infoColumns > 2 ? 2 :  5}" rowspan="4"></th>`}
              <th rowspan="4"/>
              <th colspan="${(info.shipTo ? 8 : (this.infoColumns > 2 ? 3 : 2)) * 4}" rowspan="4">
                ${info.position === 1 ? info.box ? this.printInfoBox(salesOrder, Math.min(info.shipTo?2:3, this.infoColumns), 2) : this.printInfoPlain(salesOrder) : ``}
              </th>
            </tr>
            <tr>
              <th colspan="5" rowspan="3" style="padding:4px 8px;${this.form.valueLines?`border:1px solid #888;${this.title.lines?`border-top:none`:``}`:``}">
                ${this.displayAddress(salesOrder.billToAddress)}
              </th>
              ${info.shipTo ? `<th colspan="5" rowspan="3" style="padding:4px 8px;${this.form.valueLines?`border:1px solid #888;${this.title.lines?`border-top:none`:``}`:``}">
                                      ${this.displayAddress(salesOrder.shipToAddress)}
                                    </th>` : ''}
            </tr>
            <tr><th/></tr>
            <tr><th/></tr>
            <tr><th colspan="20">&nbsp;</th></tr>

            ${info.position === 2 ? `
            <tr>
              <th colspan="${Math.min(this.form.info.fields.length,5) * 4}">
                ${this.printInfoBox(salesOrder, Math.min(this.form.info.fields.length,5) , 2)}
              </th>
            </tr><tr><th colspan="20">&nbsp;</th></tr>` : ``}

            <tr>`];
      let i = 0;
      let totalColspan = 0;
      for (const columnName of this.form.columns) {
        const column = this.columns.find(column => column.name === columnName);
        i++;
        const colspan = this.$roundNumber(20*column.width/this.totalWidth, 0);
        lines.push(`<th colspan="${i < this.form.columns.length ? colspan : 20-totalColspan}"
                        class="title-style ${column.right?`right`:``}" ${i>1 ? `style="border-left:none"`:``}>${column.title}</th>`);
        totalColspan += colspan;
      }
      lines.push(`
              </tr>
            </thead>
          <tbody>
          `);

      let subTotal = 0;
      let lastColumnWidth = 0;
      salesOrder.lines.forEach(line => {
        lines.push(`<tr>`);
        subTotal += line.amount;
        i = 0;
        totalColspan = 0;
        for (const columnName of this.form.columns) {
          i++;
          const column = this.columns.find(column => column.name === columnName);
          let style = '';
          if (this.form.valueLines) {
            if (i === 1)
              style = `style="border-left:1px solid #888${this.form.columnDividers?`;border-right:1px solid #888`:``}"`;
            else if (i === this.form.columns.length)
              style = `style="border-right:1px solid #888"`;
            else if (this.form.columnDividers)
              style = `style="border-right:1px solid #888"`;
          }
          const colspan = this.$roundNumber(20*column.width/this.totalWidth, 0);
          lines.push(`<td colspan="${i === this.form.columns.length ? 20-totalColspan : colspan}" ${column.right?`class="right"`:``} ${style}>`);
          totalColspan += colspan;
          switch (columnName) {
            case 'sku':
              lines.push(line[columnName] ?? `&nbsp;`);
              break;
            case 'description':
              lines.push(`${line[columnName]}`);
              break;
            case 'tax':
              lines.push(salesOrder.taxLines.find(t => t.id === line.taxCodeId)?.name ?? '');
              break;
            case 'quantity':
              lines.push(`${this.$number(line.quantity, line.precision)} ${line.units}`);
              break;
            case 'unitPrice':
              lines.push(this.$number(line.unitPrice, 4));
              break;
            case 'amount':
              lines.push(this.$number(line.amount, 2));
              lastColumnWidth = colspan;
              break;
          }
          lines.push('</td>');
        }
        lines.push(`</tr>`);

/*
        if (line.items)
          line.items.forEach(bundleLine => {
            subTotal += bundleLine.amount;
            lines.push(`<tr>
                          <td colspan="3">${bundleLine.sku}</td>
                          <td colspan="11">${bundleLine.description}</td>
                          <td colspan="3" class="right">${this.$number(bundleLine.quantity, bundleLine.precision)} ${bundleLine.units}</td>
                          <td colspan="3" class="right">${this.$number(bundleLine.weight, 3)} kg</td>
                        </tr>`);
          });
*/
      });

      lines.push(`<tr>
                    <td colspan="10" rowspan="${3+salesOrder.taxLines.length+(salesOrder.discount.amount?1:0)}" class="separator">${salesOrder.memo}</td>`);
      if (lastColumnWidth)
        lines.push(`  <td colspan="${10-lastColumnWidth}" class="total-line separator">SUBTOTAL</td>
                      <td colspan="${lastColumnWidth}" class="total-line separator">${this.$number(subTotal, 2)}</td>`);
      else
        lines.push(`  <td colspan="10" class="separator"></td>`);
      lines.push(`</tr>`);
      let total = subTotal;
      if (lastColumnWidth) {
        if (salesOrder.discount.amount) {
          lines.push(`<tr>
                        <td colspan="${10-lastColumnWidth}" class="total-line">Discount
                          ${salesOrder.discount.percent ? `${this.$number(salesOrder.discount.amount,2)}%` : `$${this.$number(salesOrder.discount.amount,2)}`}
                        </td>
                        <td colspan="${lastColumnWidth}" class="total-line">
                          - ${this.$number(salesOrder.discount.value,2)}
                        </td>
                      </tr>`);
          total -= salesOrder.discount.value;
        }
        salesOrder.taxLines.forEach(tax => {
          lines.push(`<tr>
                        <td colspan="${10-lastColumnWidth}" class="total-line">${tax.name} @ ${tax.percent}% on $${this.$number(tax.onAmount,2)}</td>
                        <td colspan="${lastColumnWidth}" class="total-line">${this.$number(tax.amount,2)}</td>
                      </tr>`);
          total += tax.amount;
        })
        lines.push(`<tr>
                      <td colspan="${10-lastColumnWidth}" class="total-line"><strong>TOTAL</strong></td>
                      <td colspan="${lastColumnWidth}" class="total-line" style="${this.form.valueLines && this.form.totalLines ? ';border-bottom:thin solid #888' : ''}"><strong>${this.$number(total, 2)}</strong></td>
                    </tr>`);
      }

      lines.push(`</tbody>
                </table>`);

      return lines.join('');

      }
    }
}

export default salesOrderPrintHTML;